import type { IColumn } from '@fluentui/react';
import { Stack } from '@fluentui/react';
import { Item, itemStylesTag, ListRow } from '@h2oai/ui-kit';

import type { Tag } from '../../../authz/gen/ai/h2o/workspace/v1/tag_pb';
import type { Workspace } from '../../../authz/gen/ai/h2o/workspace/v1/workspace_pb';

interface WorkspaceListRowProps {
  item: { [key: string]: any };
  columns?: IColumn[];
  tagsMap: Map<string, Tag>;
}

export const WorkspaceListRow = (props: WorkspaceListRowProps) => {
  const { item, columns = [], tagsMap } = props;
  const workspace = item as Workspace;

  return (
    <Stack>
      <ListRow
        data={item}
        columns={columns}
        contents={item?.contents}
        hasLeftOpenClose={item?.hasLeftOpenClose}
        hasOpenClose={item?.hasLeftOpenClose}
        openCloseByButton={item?.hasLeftOpenClose}
        collapsed={item?.collapsed}
      />
      {workspace.tags && workspace.tags.length > 0 && (
        <Stack horizontal tokens={{ childrenGap: 8 }} styles={{ root: { paddingLeft: 24, paddingBottom: 8 } }}>
          {workspace.tags.map((tagName: string) => {
            const tagData = tagsMap.get(tagName);
            if (!tagData) return null;

            return (
              <Item
                key={tagName}
                styles={itemStylesTag}
                labelField="displayName"
                titleField="description"
                hasTooltip
                emptyTooltip="No description available."
                data={tagData}
              />
            );
          })}
        </Stack>
      )}
    </Stack>
  );
};
